import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

/**
 * Button triggers that stand in for an input (e.g. month pickers) share the
 * white default input surface: Neutral700 text, Neutral500 border.
 */
export const inputTriggerSx: SystemStyleObject<Theme> = {
  backgroundColor: "var(--neutral-white)",
  color: "text.primary",
  borderColor: "action.active",
  // Override the theme's filled outlined-button hover; stay an input surface.
  "&:hover": {
    backgroundColor: "var(--neutral-white)",
    color: "text.primary",
    borderColor: "text.primary",
  },
  "& .MuiButton-endIcon": { color: "primary.main" },
};
